export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '3.0.57'
};
